import React from 'react';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { t } from '../../lang';
import BillingHeader from './components/BillingHeader/BillingHeader';
import BillingHistory from './components/BillingHistory';

import './BillingCurrency.scss';

const { name } = AppConfig;

const BillingCurrency = () => {
	return (
		<div className='BillingCurrency'>
			<PageHeader />
			<div className='BillingCurrency__body'>
				<BillingHeader
					title={t('{billingName} USD Mobile Balance', { billingName: name })}
					description={t('{billingName} Mobile balance is needed to pay for Mobile Wallet services...', {
						billingName: name,
					})}
				/>

				<BillingHistory />
			</div>
		</div>
	);
};

export default BillingCurrency;
